import React, { useState } from 'react';
import AddSlideModal from './AddSlideModal';
import CarouselList from './CarouselList';

const CarouselManager = () => {
  const [carouselItems, setCarouselItems] = useState([
    // Initially empty array to demonstrate "No slides" message
    // Uncomment the sample data below to see slides displayed
    // { id: 1, image: 'https://via.placeholder.com/1200x400?text=Carousel+1', title: 'Summer Collection', subtitle: 'Discover our new fragrances', isActive: true },
    // { id: 2, image: 'https://via.placeholder.com/1200x400?text=Carousel+2', title: 'Limited Edition', subtitle: 'Exclusive perfumes', isActive: true },
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAddItem = (newItem) => {
    setCarouselItems([...carouselItems, newItem]);
    setIsModalOpen(false); // Close the modal after adding
  };

  const handleToggleActive = (id) => {
    setCarouselItems(carouselItems.map(item => 
      item.id === id ? { ...item, isActive: !item.isActive } : item
    ));
  };

  const handleDeleteItem = (id) => {
    setCarouselItems(carouselItems.filter(item => item.id !== id));
  };

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Manage Carousel</h2>

      {/* Add New Slide Button */}
      <div className="flex justify-end mb-6">
        <button
          onClick={() => setIsModalOpen(true)}
          className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
        >
          Add New Slide
        </button>
      </div>

      {/* Carousel List Component */}
      <CarouselList
        carouselItems={carouselItems}
        onToggleActive={handleToggleActive}
        onDelete={handleDeleteItem}
      />

      {/* Modal for Adding New Slide */}
      {isModalOpen && (
        <AddSlideModal
          onClose={() => setIsModalOpen(false)}
          onAdd={handleAddItem}
        />
      )}
    </div>
  );
};

export default CarouselManager;